// material
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import { LoginForm } from '../../components/authentication/login';
import { Container, Card, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { Link  as RouterLink} from 'react-router-dom';
import { PATH_AUTH } from './../../routes/paths';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 250,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const { state } = useLocation();

  return (
    <RootStyle title="Connexion">
       <AuthLayout>
        Vous n'avez pas de compte? &nbsp;
        <Link underline="none" variant="subtitle2" 
          state={state?.prevPage && { prevPage: state?.prevPage}}
          component={RouterLink} to={PATH_AUTH.register}>
          Inscrivez-vous
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">

        <ContentStyle>
          <Typography align="center" variant="overline" sx={{ fontSize:20, m: 5}}>
              Connexion
          </Typography>
            <LoginForm />
            <MHidden width="smUp">
            <Typography variant="subtitle2" sx={{ mt: 3, textAlign: 'center' }}>
              Vous n'avez pas de compte?&nbsp;
              <Link 
                to={PATH_AUTH.register} 
                state={state?.prevPage && { prevPage: state?.prevPage}}
                component={RouterLink}>
                Inscrivez-vous
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
